import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/shopshape/band.webp")